import { render, staticRenderFns } from "./BaseInfo4.vue?vue&type=template&id=8a1c4df0&scoped=true&"
import script from "./BaseInfo4.vue?vue&type=script&lang=js&"
export * from "./BaseInfo4.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfo4.vue?vue&type=style&index=0&id=8a1c4df0&prod&lang=css&"
import style1 from "./BaseInfo4.vue?vue&type=style&index=1&id=8a1c4df0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1c4df0",
  null
  
)

export default component.exports